
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expired-purchase",
      function () {
        return require("private-next-pages/expired-purchase/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expired-purchase"])
      });
    }
  